import { render } from "./priceTag.vue?vue&type=template&id=1eda720e"
import script from "./priceTag.vue?vue&type=script&lang=js"
export * from "./priceTag.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__